// extracted by mini-css-extract-plugin
export default {"preloadMessage":"styles_preload-message_L3o8R","heading":"styles_heading_IzKAq","message":"styles_message_JzgRs"};